<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 我的卖单 </div>
      <div class="rightForm">
        <el-input
          v-model="form.subject"
          placeholder="请输入作品名称"
        ></el-input>
        <el-date-picker
          v-model="form.date"
           value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button @click="fetchData">查询</el-button>
        <router-link :to="{path:'/OnSale/InputForm'}">
            <el-button type="primary">新增挂卖</el-button>
        </router-link>
      </div>
    </div>

    <el-table
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      @row-click="onTabelRowClick"
    >
      <el-table-column
        prop="goodsName"
        label="标题"
         show-overflow-tooltip
         width="180"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="createTimeText"
        label="交易时间"
        sortable
        width="180"
      >
        <!-- eslint-disable-next-line -->
       <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>交易时间</span>
            <a-tooltip>
              <template slot="title">
                prompt text
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ordeType"
        label="订单状态"
        width="120"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.ordeStatus=='00','stausCell2':scope.row.ordeStatus=='31','stausCell3':scope.row.ordeStatus=='10' || scope.row.ordeStatus=='11' || scope.row.ordeStatus=='21' || scope.row.ordeStatus=='22'}"
          >
            {{scope.row.ordeType}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="num"
        label="数量"
        width="80"
      >
      </el-table-column>
       <el-table-column
        prop="price"
        label="收款(元)"
        width="80"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        fixed="right"
        align="right"
      >
        <template slot-scope="scope"> 
          <el-button type="text" @click.stop="goDetail(scope.row.goodsId)">订单详情</el-button>  
          <a-icon type="right" class="ml12 gray" />

        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
       :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>

  </div>
</template>

<script>
// import {queryObtainOrders} from '@/api/ObtainEvidence'
import {queryUserSaleGoods} from '@/api/ObtainEvidence'
export default {
  name: 'MySaleList',
 components:{},
  data () {
    return {
         form: {
         subject: null,
        date: null
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total:0
      },
      saleGoodsFilter:{
        categoryId:null,
        name: null,
        status:'21',
        startTime:null,
        endTime:null
      },
       tableData: [
        //  {
        //   subject: '《鄂菜大全》《鄂菜大全》《鄂菜大全》',
        //   orderNo: '109000990099998',
        //   price: '333',
        //   num:'2',
        //   createTimeText: '2019-12-23 14:07',
        // }
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
 onTabelRowClick(row){
      this.$router.push({
       path:'/OnSale/ListDetail',
       query:{'detailType':'2'}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    fetchData (param) {
      // queryObtainOrders(this.pagination.page,this.pagination.pageSize,this.form).then(({data})=>{
      //     console.log("5555555555555555555555",data);
      //     // this.tableData=data.list;
      //     // this.pagination.total=data.total*1;
      //   });
      queryUserSaleGoods(this.pagination.page,this.pagination.pageSize,this.saleGoodsFilter).then(({data})=>{
        console.log("我的卖单：",data);
        let list = [];
        for (let i = 0; i < data.list.length; i++) {
          let orderStatus = data.list[i].orderStatus;
          let statusText = ''
          if(orderStatus == '00'){
            statusText = '待确认'
          }else if(orderStatus == '10'){
            statusText = '已确认'
          }else if(orderStatus == '11'){
            statusText = '筹集中'
          }else if(orderStatus == '21'){
            statusText = '已完成'
          }else if(orderStatus == '22'){
            statusText = '已评价'
          }else if(orderStatus == '31'){
            statusText = '已取消'
          }
          let orderNum = 0;
          for(let j = 0; j < data.list[i].items.length; j++){
            orderNum += data.list[i].items[j].quantity;
            list.push({
              goodsName: data.list[i].items[j].goodsName,
              orderNo: data.list[i].items[j].orderNo,
              ordeStatus: data.list[i].orderStatus,
              ordeType: statusText,
              num: orderNum,
              price: data.list[i].items[j].price,
              createTimeText:  this.dayjs(data.list[i].createTime * 1000).format("YYYY-MM-DD HH:mm:ss "),
              goodsId: data.list[i].items[j].goodsId,
            });
          }
        }
        this.tableData=list;
        this.pagination.total=data.total*1;
      });
    },
    goDetail(goodsId){
        console.log("DetailView..")
      this.$router.push({
       path:'/OnSale/DetailView',
        query:{fromWhere:'inputForm',goodsId: goodsId}
      });
    },
    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },
  }
}
</script>

<style lang='scss' scoped>
@import '../../../../assets/css/mine.scss';
</style>
